import React from 'react';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { appTranslate } from '../../../i18n';
import { PricingDetails, SubscriptionTier } from '../../../../type';
import { TierDetails } from '../types';
import { useIsDiscountPage } from '../../../hooks';
import { DiscountedPricing } from './DiscountedPricing';
import { RegularPricing } from './RegularPricing';

interface SubscriptionTiersHeaderProps {
    tierDetails: TierDetails;
    pricingDetails: PricingDetails;
    onChooseTier: () => void;
}

export const SubscriptionTiersHeader = ({
    tierDetails,
    pricingDetails,
    onChooseTier,
}: SubscriptionTiersHeaderProps) => {
    const isDiscountPage = useIsDiscountPage();

    const highlightedTier = SubscriptionTier.Standard;

    return (
        <Stack padding="6" rowGap="4" direction="column" minHeight="254px">
            <Stack rowGap="1" direction="column">
                <Text size="b_sm">{tierDetails.vendor}</Text>
                <Text fontWeight="bold" whiteSpace="nowrap">
                    {tierDetails.name}
                </Text>
            </Stack>

            {isDiscountPage ? (
                <DiscountedPricing pricingDetails={pricingDetails} />
            ) : (
                <RegularPricing tierName={tierDetails.id} pricingDetails={pricingDetails} />
            )}

            <Stack rowGap="3" direction="column" marginTop="auto">
                <Button
                    disabled={!pricingDetails.price}
                    variant={highlightedTier === tierDetails.id ? 'filled' : 'outline'}
                    size="sm"
                    fullWidth
                    style={{ minWidth: '220px' }}
                    onClick={onChooseTier}
                >
                    {appTranslate('compare_packages.actions.buy')}
                </Button>

                <Text size="b_xs" color="bodySecondary">
                    {appTranslate('compare_packages.microsoft.pricing.taxes')}
                </Text>
            </Stack>
        </Stack>
    );
};
